import { register, mount } from 'riot'
import AppShell from './ui/app-shell.riot'
import { initPwa } from './pwa'
import { initSupervisorScheduler } from './engine/supervisor/scheduler'
import { registerAllChecks } from './engine/supervisor/index'
import { getAppImportMetaEnv } from "@anyquest/shared-core"

// --- Core App Shell ---
register('app-shell', AppShell)

// --- Initialization ---
registerAllChecks()
initSupervisorScheduler()

const appEnv = getAppImportMetaEnv()
if (appEnv.PROD) initPwa()

document.body.innerHTML = '<app-shell></app-shell>'
mount('app-shell', {})
